export default {
  "settings.title": "الإعدادات",
  "settings.subtitle": "بيانات المغسلة وأمان الحساب ولغة اللوحة",

  "settings.section.laundry": "بيانات المغسلة",
  "settings.section.laundryDesc": "البيانات المعتمدة الحالية وأي طلب تعديل قيد المراجعة",
  "settings.section.security": "أمان الحساب",
  "settings.section.securityDesc": "تغيير كلمة مرور حساب المغسلة",
  "settings.section.language": "لغة اللوحة",
  "settings.section.languageDesc": "لغة عرض لوحة التحكم واتجاه الواجهة",

  "settings.approved.title": "البيانات المعتمدة",
  "settings.approved.badge": "بيانات معتمدة",
  "settings.approvedNote": "هذه هي البيانات المعتمدة الحالية والمستخدمة في اللوحة.",
  "settings.requestEdit": "طلب تعديل البيانات",

  "settings.field.name": "اسم المغسلة",
  "settings.field.description": "الوصف",
  "settings.field.logo": "الصورة أو الشعار",
  "settings.field.phone": "رقم الهاتف",
  "settings.field.address": "عنوان المغسلة على الخريطة",
  "settings.field.coverage": "الأحياء التي تغطيها المغسلة",
  "settings.field.workingHours": "أوقات العمل",
  "settings.field.normalDuration": "مدة التنفيذ العادي",
  "settings.field.urgentDuration": "مدة التنفيذ المستعجل",

  "settings.value.notSet": "لم تُحدد بعد",
  "settings.value.currentLogo": "الشعار الحالي",
  "settings.value.newLogo": "شعار جديد",
  "settings.unit.hours": "ساعة",
  "settings.coverage.none": "لا توجد أحياء محددة",
  "settings.address.notSet": "لم يُحدد العنوان بعد",
  "settings.duration.scope": "المدد تخص المغسلة بالكامل وتبدأ من استلام الطلب فعليًا.",

  "settings.mod.title": "حالة طلب التعديل",
  "settings.mod.status.label": "حالة الطلب",
  "settings.mod.status.under_review": "قيد المراجعة",
  "settings.mod.status.approved": "تمت الموافقة",
  "settings.mod.status.rejected": "مرفوض",
  "settings.mod.underReviewNote": "طلب التعديل بانتظار مراجعة الإدارة، وتبقى البيانات المعتمدة الحالية مستخدمة.",
  "settings.mod.approvedNote": "تمت الموافقة على التعديل واعتماد القيم الجديدة من النظام.",
  "settings.mod.rejectedNote": "تم رفض طلب التعديل، ولا تزال البيانات السابقة سارية.",
  "settings.mod.noneTitle": "لا يوجد طلب تعديل",
  "settings.mod.noneText": "البيانات المعروضة هي البيانات المعتمدة الحالية.",
  "settings.mod.rejectionReason": "سبب الرفض",
  "settings.mod.submittedAt": "تاريخ الإرسال",
  "settings.mod.changesTitle": "التعديلات المطلوبة",
  "settings.mod.noChanges": "لا توجد تغييرات مسجلة في هذا الطلب.",
  "settings.mod.approvedChangesTitle": "ما تم اعتماده",
  "settings.mod.col.field": "الحقل",
  "settings.mod.col.current": "القيمة المعتمدة الحالية",
  "settings.mod.col.requested": "القيمة المطلوبة",
  "settings.mod.col.previous": "القيمة السابقة",
  "settings.mod.col.approvedValue": "القيمة المعتمدة الجديدة",
  "settings.mod.eligibilityNote": "لا يمكن إرسال طلب تعديل جديد قبل مراجعة الطلب الحالي.",

  "settings.form.title": "طلب تعديل البيانات",
  "settings.form.desc": "عدّل الحقول المطلوبة ثم أرسل الطلب إلى الإدارة للمراجعة.",
  "settings.form.basic": "البيانات الأساسية",
  "settings.form.addressCoverage": "العنوان والتغطية",
  "settings.form.hours": "أوقات العمل",
  "settings.form.durations": "مدد التنفيذ",
  "settings.form.name": "اسم المغسلة",
  "settings.form.description": "الوصف",
  "settings.form.logo": "الصورة أو الشعار",
  "settings.form.phone": "رقم الهاتف",
  "settings.form.city": "المدينة",
  "settings.form.district": "الحي",
  "settings.form.street": "الشارع",
  "settings.form.building": "رقم المبنى",
  "settings.form.coverage": "الأحياء التي تغطيها المغسلة",
  "settings.form.coverageHint": "اختر الأحياء من الأحياء التشغيلية المتاحة في مدينة المغسلة.",
  "settings.form.fromTime": "من الساعة",
  "settings.form.toTime": "إلى الساعة",
  "settings.form.normalHours": "مدة التنفيذ العادي (ساعة)",
  "settings.form.urgentHours": "مدة التنفيذ المستعجل (ساعة)",
  "settings.form.durationHint": "المدد تخص المغسلة بالكامل، وتبدأ من استلام المغسلة للطلب فعليًا.",
  "settings.form.addressHint": "حدّد الحي والشارع ورقم المبنى لتحديد العنوان على الخريطة.",
  "settings.form.mapPreview": "معاينة الموقع على الخريطة",
  "settings.form.submit": "إرسال طلب تعديل",
  "settings.form.cancel": "إلغاء",
  "settings.form.note": "تُرسل التعديلات إلى الإدارة للمراجعة، وتبقى البيانات الحالية سارية حتى الموافقة.",
  "settings.form.error.name": "اسم المغسلة مطلوب",
  "settings.form.error.description": "الوصف مطلوب",
  "settings.form.error.phone": "رقم الهاتف مطلوب",
  "settings.form.error.phoneFormat": "أدخل رقم هاتف بصيغة صحيحة",
  "settings.form.error.duration": "أدخل مدة رقمية موجبة",
  "settings.form.error.noChanges": "القيم المدخلة تطابق البيانات الحالية، لذلك لم يتم إرسال أي تعديل.",
  "settings.form.error.submit": "تعذّر إرسال طلب التعديل، حاول مرة أخرى.",
  "settings.form.highlightDurations": "حقول مدة التنفيذ مبرزة أدناه.",

  "settings.image.choose": "اختيار شعار",
  "settings.image.replace": "استبدال الشعار",
  "settings.image.remove": "إزالة الشعار المختار",
  "settings.image.none": "لم يُضف شعار",
  "settings.image.hint": "اختيار شعار جديد يعني استبدال الشعار الحالي بعد موافقة الإدارة.",
  "settings.image.tooLarge": "حجم الملف أكبر من الحد المسموح ({size} م.ب).",
  "settings.image.wrongType": "صيغة الملف غير مدعومة.",

  "settings.toast.submitted": "تم إرسال طلب التعديل للمراجعة",
  "settings.toast.password": "تم تغيير كلمة المرور",

  "settings.password.title": "تغيير كلمة المرور",
  "settings.password.desc": "غيّر كلمة مرور الدخول إلى لوحة التحكم.",
  "settings.password.current": "كلمة المرور الحالية",
  "settings.password.new": "كلمة المرور الجديدة",
  "settings.password.confirm": "تأكيد كلمة المرور الجديدة",
  "settings.password.submit": "تغيير كلمة المرور",
  "settings.password.submitting": "جارٍ التغيير…",
  "settings.password.show": "إظهار",
  "settings.password.hide": "إخفاء",
  "settings.password.error.required": "يرجى تعبئة جميع حقول كلمة المرور",
  "settings.password.error.mismatch": "كلمة المرور الجديدة وتأكيدها غير متطابقين",
  "settings.password.error.minLength": "كلمة المرور يجب ألا تقل عن {{count}} أحرف",
  "settings.password.error.wrongCurrent": "كلمة المرور الحالية غير صحيحة",
  "settings.password.error.generic": "تعذّر تغيير كلمة المرور، حاول مرة أخرى.",
  "settings.password.successNote": "يسري تغيير كلمة المرور فورًا دون اعتماد الإدارة.",
  "settings.password.policyNote": "تُطبّق سياسة كلمة المرور المعتمدة من النظام.",

  "settings.lang.current": "اللغة الحالية",
  "settings.lang.ar": "العربية",
  "settings.lang.en": "English",
  "settings.lang.arDesc": "نصوص عربية واتجاه من اليمين إلى اليسار",
  "settings.lang.enDesc": "نصوص إنجليزية واتجاه من اليسار إلى اليمين",
  "settings.lang.selected": "المحددة",
  "settings.lang.note": "يشمل التغيير جميع صفحات اللوحة ورسائل التحميل والفراغ والخطأ والنجاح، مع الحفاظ على الصفحة الحالية والمدخلات غير المرسلة.",

  "settings.error": "تعذّر تحميل الإعدادات",
  "settings.demoNote": "هذه معاينة ببيانات تجريبية."
};